module.exports = __webpack_public_path__ + "img/banner.3ddd63b6.png";